import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Lock, Server, Eye, CheckCircle } from 'lucide-react';
import Navbar from '../components/Navbar';
import { VerifiedByVisa, MastercardIDCheck, VisaLogo, MastercardLogo, AzulBadge } from '../components/PaymentBadges';

export default function Seguridad() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const items = [
    {
      icon: <ShieldCheck className="w-6 h-6 text-green-600" />,
      title: t('security.pciTitle'),
      text: t('security.pciText'),
    },
    {
      icon: <Lock className="w-6 h-6 text-[#134168]" />,
      title: t('security.tlsTitle'),
      text: t('security.tlsText'),
    },
    {
      icon: <Server className="w-6 h-6 text-purple-600" />,
      title: t('security.noStoreTitle'),
      text: t('security.noStoreText'),
    },
    {
      icon: <Eye className="w-6 h-6 text-orange-500" />,
      title: t('security.fraudTitle'),
      text: t('security.fraudText'),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-24 lg:pb-0">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <button
          onClick={() => navigate(-1)}
          className="mb-8 text-sm text-gray-500 hover:text-[#134168] transition-colors"
        >
          {t('legal.back')}
        </button>

        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">
          {t('security.title')}
        </h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.lastUpdatedMay')}</p>

        {/* Intro */}
        <div className="bg-white rounded-3xl p-8 shadow-sm mb-6 text-gray-700 text-sm leading-relaxed">
          <p>{t('security.intro')}</p>
        </div>

        {/* Medidas de seguridad */}
        <div className="space-y-4 mb-8">
          {items.map((item, i) => (
            <div key={i} className="bg-white rounded-3xl p-6 shadow-sm flex gap-4 items-start">
              <div className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center shrink-0">
                {item.icon}
              </div>
              <div>
                <h2 className="font-bold text-[#134168] mb-1">{item.title}</h2>
                <p className="text-sm text-gray-600">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Autenticación 3D Secure */}
        <div className="bg-[#134168] text-white rounded-3xl p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-heading font-bold mb-2">{t('security.threeDSTitle')}</h2>
          <p className="text-blue-100 text-sm mb-6">{t('security.threeDSText')}</p>

          <div className="flex flex-wrap gap-4 items-center">
            <VerifiedByVisa className="h-10" />
            <MastercardIDCheck className="h-10" />
          </div>

          <ul className="mt-6 space-y-2">
            {[t('security.threeDS1'), t('security.threeDS2'), t('security.threeDS3')].map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-sm text-blue-100">
                <CheckCircle className="w-4 h-4 text-green-400 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Métodos de pago aceptados */}
        <div className="bg-white rounded-3xl p-8 shadow-sm">
          <h2 className="text-lg font-bold text-[#134168] mb-4">{t('security.paymentMethodsTitle')}</h2>
          <div className="flex flex-wrap gap-4 items-center">
            <VisaLogo className="h-8" />
            <MastercardLogo className="h-8" />
            <AzulBadge className="h-8" />
          </div>
          <p className="text-xs text-gray-400 mt-4">{t('security.paymentMethodsNote')}</p>
        </div>
      </div>
    </div>
  );
}
